'use client';

import { useCallback } from 'react';
import { useRouter } from 'next/navigation';

function normalizePath(target: string) {
  if (!target || target === '/' || target === 'home') {
    return '/app';
  }

  if (target === 'loginPage' || target === 'auth') {
    return '/auth';
  }

  if (target.startsWith('/')) {
    return target;
  }

  return `/app/${target}`.replace(/\/+$/, '').replace(/\/+/, '/');
}

function usePageNavigation() {
  const router = useRouter();

  const navigateNextPage = useCallback(
    (toPage: string) => {
      const path = normalizePath(toPage);
      try {
        sessionStorage.setItem('visitedRoute', path);
      } catch {
        // noop - accessing sessionStorage might fail in private mode; ignore
      }
      router.push(path);
    },
    [router],
  );

  const nagivatePreviousPage = useCallback(
    (toPage: string) => {
      const path = normalizePath(toPage);
      try {
        sessionStorage.setItem('visitedRoute', path);
      } catch {
        // ignore storage issues
      }
      router.push(path);
    },
    [router],
  );

  return {
    navigateNextPage,
    nagivatePreviousPage,
  };
}

export default usePageNavigation;
